import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { yourHome } from 'src/lib/flow/text';

import { FlowContext } from '../../../../lib/flow';

function isEnabled() {
  return true;
}

function title({ answers, inputContext: { channel } }: FlowContext): string {
  return `Is ${yourHome(answers, channel)} part of a homeowners association?`;
}

const hoaGuardPage: FlowPage = {
  slug: () => 'hoa-guard',
  isEnabled,
  title,
  subtitle: () =>
    "This is often called an HOA. It's a group that helps maintain your community for a fee.",
  autoAdvance: () => true,
  questions: (): FlowQuestion[] => {
    return [
      {
        key: 'home.hoa',
        type: 'radio_single_select',
        options: [
          {
            label: 'Yes',
            value: 'yes',
          },
          {
            label: 'No',
            value: 'no',
          },
        ],
      },
    ];
  },
};

export default hoaGuardPage;
